import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { env } from '@/shared/config/env';

import { twa } from './twa';

export const useTelegramBackButton = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (env.ENVIRONMENT === 'production' && !twa.isInsideTelegram()) return;

    const handleBack = () => navigate(-1);

    twa.backButton.show();
    twa.backButton.onClick(handleBack);

    return () => {
      twa.backButton.hide();
      twa.backButton.offClick(handleBack);
    };
  }, [navigate]);
};
